import { cn } from "@stackmorph/utils";

type Props = {
  size?: number;
  className?: string;
};

export const Logo = ({ size = 32, className }: Props) => {
  return (
    <img
      src="/logo/logo.png"
      width={size}
      height={size}
      alt="Stackmorph Resume Builder"
      className={cn("rounded-sm", className)}
    />
  );
};

